module.exports = __webpack_public_path__ + "static/bbis-commercial-boiler-repair-abc7b29e5b50b7dcbdc2354e8c763d6a.jpeg";